import { createFeatureSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { DEFAULT_SCHEDULE_PARAMS } from './appointment-data.data';
import {
  entityReducerMap,
  IEntityList,
  IEntityState,
  IFilteredLists,
  initialListState,
} from '../entity-data/entity-data.reducer';
import { EntityTypesEnum } from '../../app.enum';

// feature name
export const FEATURE_NAME = 'appointment-data';

// state interface
export interface IState extends IEntityState {}

// initial states of store
export const initialScheduleState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SCHEDULE_PARAMS,
};

export const initialFilteredListsState: IFilteredLists = {
  all: initialScheduleState,
  search: initialScheduleState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  dispatchedResponse: null,
};

// reducer
const reducerFn = handleActions(
  {
    ...entityReducerMap<IState>(),
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload &&
    action.payload.entityType === EntityTypesEnum.appointment
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);
